import { render, staticRenderFns } from "./WeekRoomsChart.vue?vue&type=template&id=e37c9c56&scoped=true&"
import script from "./WeekRoomsChart.vue?vue&type=script&lang=js&"
export * from "./WeekRoomsChart.vue?vue&type=script&lang=js&"
import style0 from "./WeekRoomsChart.vue?vue&type=style&index=0&id=e37c9c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37c9c56",
  null
  
)

export default component.exports